// extracted by mini-css-extract-plugin
export default {"child":"_4nwOy","remover":"rKT4-","icon":"o-d-J","addChildBlock":"seKLW","agesTitle":"iyBSa","age":"-Y6q5","age--isLast":"ZBnhY","agesList":"l0AiI","skeleton-progress":"vZyuB"};